import { ITranslationMap } from '@principle-theorem/practice-migrations/interfaces';
import { IFeeSchedule } from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  INamedDocument,
  IXSLXExport,
  XSLXCell,
  isSameRef,
} from '@principle-theorem/shared';
import { Column } from 'exceljs';
import { IBaseMigrationFeeSchedule } from './fee-schedules';

export interface IFeeScheduleToXSLX {
  label: string;
  mapTo: string;
}

export const FEE_SCHEDULE_HEADERS: AtLeast<Column, 'key' | 'header'>[] = [
  {
    key: 'label',
    header: 'Fee Schedule',
    width: 30,
  },
  {
    key: 'mapTo',
    header: 'Map To',
    width: 30,
  },
];

export class FeeSchedulesToXSLX
  implements IXSLXExport<IBaseMigrationFeeSchedule, IFeeScheduleToXSLX>
{
  headers = FEE_SCHEDULE_HEADERS;

  constructor(
    private _feeSchedules: INamedDocument<IFeeSchedule>[],
    private _existingMappings: ITranslationMap<IFeeSchedule>[]
  ) {}

  translate(
    records: IBaseMigrationFeeSchedule[]
  ): Record<keyof IFeeScheduleToXSLX, XSLXCell>[] {
    return records.map((record) => {
      const existingRecord = this._existingMappings.find(
        (existingMapping) =>
          existingMapping.sourceIdentifier === record.id.toString()
      );

      const destinationIdentifier = existingRecord?.destinationIdentifier;
      const mappedFeeSchedule = destinationIdentifier
        ? this._feeSchedules.find((feeSchedule) =>
            isSameRef(feeSchedule.ref, destinationIdentifier)
          )
        : undefined;

      return {
        label: { value: record.name },
        mapTo: {
          value: mappedFeeSchedule?.name || '',
          dataValidation: {
            type: 'list',
            formulae: [
              `"${this._feeSchedules
                .map((feeSchedule) => feeSchedule.name)
                .join(',')}"`,
            ],
          },
        },
      };
    });
  }
}
